import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { closeLoading, showLoading } from '../../Reducer/LoadingReducer';
import { useRef } from 'react';

const useSaveMutation = (mutationFn, options = {}, showLoadingFlag = true) => {
  const dispatch = useDispatch();
  const loadingTimer = useRef(null);
  const mutation = useMutation({
    mutationFn,

    onMutate: () => {
      if (showLoadingFlag) {
        if (loadingTimer.current) clearTimeout(loadingTimer.current);

        loadingTimer.current = setTimeout(() => {
          dispatch(showLoading());
        }, 500);
      }
    },

    onSuccess: (response, vars, context) => {
      // 응답 그대로 사용 - 파싱 불필요
      // if (response.severity === 'error') {
      //   const err = new Error(response.message);
      //   err.response = response;
      //   options.onError?.(err, vars, context);
      //   throw err;
      // }

      options.onSuccess?.(response, vars, context);
      return response;
    },

    onError: (e) => {
      options.onError?.(e);
    },

    onSettled: () => {
      if (loadingTimer.current) {
        clearTimeout(loadingTimer.current);
        loadingTimer.current = null;
      }

      dispatch(closeLoading());
    },
  });

  return {
    ...mutation,
    run: (params) => mutation.mutate(params),
    runAsync: (params) => mutation.mutateAsync(params),
  };
};

export default useSaveMutation;
